import { Divider, Typography, type DividerProps } from "@mui/material";

type Props = DividerProps & {
  text?: string;
  marginY?: number;
  marginTop?: number;
};

export const BlDivider = ({
  text,
  marginY = 4,
  marginTop,
  ...props
}: Props) => (
  <Divider
    sx={{
      ...(marginY !== undefined && {
        marginY: (theme) => theme.spacing(marginY),
      }),
      ...(marginTop !== undefined && {
        marginTop: (theme) => theme.spacing(marginTop),
      }),
    }}
    variant={text ? "middle" : "fullWidth"}
    {...props}
  >
    {!!text && <Typography color="gray">{text}</Typography>}
  </Divider>
);
